import { createReducer, on } from '@ngrx/store';
import { OperatorActions } from '@states/operator/operator.action-types';
import { Operator } from '../../../operator/operator.model';
import { deleteUnitEdge, setDeletingEdge } from '@states/operator/operator.actions';

export declare interface OperatorState {
  isSaving: boolean;
  isLoading: boolean;
  edgeDocument: Operator.EdgeDocument;
  speakersCredentialList: Operator.SpeakerCredentialItem[];
  isFormValid: boolean;
  speakerUsername: string;
  selectedEdge: Operator.EdgeDocument;
  speakerPassword: string;
  unprovisionLoading: boolean;
  deletingEdge: boolean;
}

const initialState: OperatorState = {
  isSaving: false,
  isLoading: false,
  edgeDocument: null,
  speakersCredentialList: [],
  isFormValid: false,
  speakerUsername: null,
  speakerPassword: null,
  unprovisionLoading: false,
  deletingEdge: false,
  selectedEdge: null,
};

export const operatorReducer = createReducer(
  initialState,
  on(OperatorActions.resetToInitialState, (state) => {
    return {
      ...state,
      ...initialState,
    };
  }),
  on(OperatorActions.setIsSaving, (state, { isSaving }) => {
    return {
      ...state,
      isSaving,
    };
  }),
  on(OperatorActions.setIsLoading, (state, { isLoading }) => {
    return {
      ...state,
      isLoading,
    };
  }),
  on(OperatorActions.createEdge, (state) => {
    return {
      ...state,
      isSaving: true,
    };
  }),
  on(OperatorActions.createEdgeSuccess, (state, { edge }) => {
    return {
      ...state,
      edgeDocument: edge,
    };
  }),
  on(OperatorActions.updateEdge, (state) => {
    return {
      ...state,
      isSaving: true,
    };
  }),
  on(OperatorActions.getSpeakerCredentialListSuccess, (state, { list }) => {
    return {
      ...state,
      speakersCredentialList: list,
    };
  }),
  on(OperatorActions.setIsFormValid, (state, { isFormValid }) => {
    return {
      ...state,
      isFormValid,
    };
  }),
    on(OperatorActions.clearCurrentEdge, (state) => ({
    ...state,
    edgeDocument: null
  })),
  on(OperatorActions.createSpeaker, (state) => {
    return {
      ...state,
      isSaving: true,
    };
  }),
  on(OperatorActions.createSpeakerSuccess, (state, { username, password }) => {
    return {
      ...state,
      speakerUsername: username,
      speakerPassword: password,
    };
  }),
  on(OperatorActions.getCloudEdge, (state) => {
    return {
      ...state,
      isLoading: true,
    };
  }),
  on(OperatorActions.getCloudEdgeSuccess, (state, { edge }) => {
    return {
      ...state,
      edgeDocument: edge,
    };
  }),
  on(OperatorActions.getEdgeByIdSuccess, (state, { edge }) => {
    return {
      ...state,
      selectedEdge: edge,
    };
  }),
  on(OperatorActions.getUnitEdge, (state) => {
    return {
      ...state,
      isLoading: true,
    };
  }),
  on(OperatorActions.getUnitEdgeSuccess, (state, { edge }) => {
    return {
      ...state,
      edgeDocument: edge,
    };
  }),
  on(OperatorActions.unprovisionEdge, (state) => {
    return {
      ...state,
      unprovisionLoading: true,
    };
  }),
  on(OperatorActions.setUnprovisionEdgeLoader, (state, { unprovisionLoading }) => {
    return {
      ...state,
      unprovisionLoading,
    };
  }),
  on(OperatorActions.deleteUnitEdge, (state) => {
    return {
      ...state,
      deletingEdge: true,
    };
  }),
  on(OperatorActions.setDeletingEdge, (state, { deletingEdge }) => {
    return {
      ...state,
      deletingEdge,
    };
  }),
);
